import React, { useState } from "react";
import { connect } from "react-redux";
import { func, any } from "prop-types";
import CloseIcon from "../../icons/CloseIcon";
import * as style from "./styles.module.scss";
import {
  userFeedback,
  userFeedbackDismissal,
  userFeedbackClose,
} from "../../redux/actions";
import SurveyCreator from "./SurveyCreator";

const Feedback = ({
  appData,
  setCloseFeedback,
  userFeedbackFunc,
  userDismissalFunc,
  userFeedbackCloseFunc,
}) => {
  const { activeQuestions } = appData.surveyData;

  const [step, setStep] = useState(0);
  const [values, setValues] = useState({});

  const handleSubmit = () => {
    const convertValuesFromList = Object.keys(values).map((el) => {
      if (Array.isArray(values[el])) {
        const newValue = values[el].join(" | ", ", ");
        return { id: el, value: newValue };
      }
      return { id: el, value: values[el].toString() };
    });
    setStep(step + 1);
    userFeedbackFunc(convertValuesFromList);
    setTimeout(() => {
      userFeedbackCloseFunc();
    }, 3000);
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleClose = () => {
    userDismissalFunc();
    setCloseFeedback(true);
  };

  return (
    <div className={style.container}>
      {step !== activeQuestions.length && (
        <div
          onClick={() => {
            handleClose();
          }}
          className={style.close}
        >
          <CloseIcon />
        </div>
      )}
      <div className={style.feedback}>
        <div className={style.info}>
          <div
            style={{
              fontSize: "14px",
              marginLeft: window.innerWidth > 811 ? "60px" : "0px",
            }}
            onClick={() => setStep(0)}
          >
            Please help us improve!
          </div>
          <div
            style={{
              fontSize: "12px",
              marginLeft: window.innerWidth > 811 ? "60px" : "0px",
            }}
          >
            We would love to hear your thoughts on your experience with HRGO
            Recruitment.
            <br />
            Please can you take a couple of minutes to fill out this short
            survey?
            <br />
            All of the feedback we receive will be used to enable us to improve
            our overall service and customer satisfaction.
          </div>
        </div>
        <SurveyCreator
          values={values}
          setValues={setValues}
          step={step}
          handleNext={handleNext}
          handleSubmit={handleSubmit}
          activeQuestions={activeQuestions}
        />
      </div>
    </div>
  );
};

Feedback.propTypes = {
  appData: any,
  setCloseFeedback: func,
};

const mapDispatchToProps = {
  userFeedbackFunc: userFeedback,
  userDismissalFunc: userFeedbackDismissal,
  userFeedbackCloseFunc: userFeedbackClose,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(Feedback);
